module.exports = __webpack_public_path__ + "img/logo.cbac4661.png";